import ISOToLocal from './ISOToLocal';

function toLocalDate(date: string | Date): Date {
	return typeof date === 'string' ? ISOToLocal(date) : date;
}

export default toLocalDate;
